// The one piece of the mobile app deliberately NOT imported from ../src/utils.
//
// Everything else shared (targetHelpers, tierTree, agentMatching,
// defaultProject, theme, uploadHelpers) is plain JS and imports cleanly.
// ProjectContext.js contains JSX inside a .js file - legal under React
// Native's Metro bundler, but Vite/rollup will not parse it, and the loader
// override doesn't reach files outside the project root. Renaming it would
// break the mobile app's imports.
//
// Duplicating it is safe in a way duplicating the others is not: this is React
// boilerplate with no rules in it, so the two copies cannot disagree about
// anything that matters. The API is identical, so pages ported from mobile use
// useProject() unchanged.
import React, { createContext, useContext } from 'react';

const ProjectContext = createContext({ project: null, refreshProject: async () => {} });

export function ProjectProvider({ project, refreshProject, children }) {
  return (
    <ProjectContext.Provider value={{ project, refreshProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  return useContext(ProjectContext);
}
